import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.css";
import todoImage from "../image/todo.png";

const TodoList = () => {
  // State variables
  const [tasks, setTasks] = useState([]); // Holds the list of tasks
  const [inputValue, setInputValue] = useState(""); // Holds the value of the input field
  const [filter, setFilter] = useState("all"); // Holds the current filter type
  const [isLoading, setIsLoading] = useState(true); // Indicates whether the data is being loaded
  const [editTaskId, setEditTaskId] = useState(null); // Holds the ID of the task being edited

  // Fetch initial data
  useEffect(() => {
    fetchTodos();
  }, []);

  // Fetch todos from an API
  const fetchTodos = async () => {
    try {
      const response = await fetch(
        "https://task-manager-json-server-88du.onrender.com/tasks"
      );
      const todos = await response.json();
      setTasks(todos);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  // Handle input change
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  // Add a new task
  const handleAddTask = async () => {
    if (inputValue.trim() === "") {
      return;
    }

    const newTask = {
      title: inputValue,
      completed: false,
    };

    try {
      const response = await fetch(
        "https://task-manager-json-server-88du.onrender.com/tasks",
        {
          method: "POST",
          body: JSON.stringify(newTask),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      const addedTask = await response.json();
      setTasks((prevTasks) => [...prevTasks, addedTask]);
      setInputValue("");
      toast.success("Task added successfully");
    } catch (error) {
      console.log("Error adding task:", error);
      toast.error("Error adding task");
    }
  };

  // Handle checkbox change for a task
  const handleTaskCheckboxChange = async (taskId) => {
    setTasks((prevTasks) =>
      prevTasks.map((tasks) =>
        tasks.id === taskId ? { ...tasks, completed: !tasks.completed } : tasks
      )
    );
    const filterObj = tasks.filter((e) => e.id === taskId);
    let newObj = {
      title: filterObj[0].title,
      completed: !filterObj[0].completed,
    };
    try {
      await fetch(
        `https://task-manager-json-server-88du.onrender.com/tasks/${taskId}`,
        {
          method: "PUT",
          body: JSON.stringify(newObj),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      toast.success("Action marked");
    } catch (error) {
      toast.error("Error completing task");
    }
  };

  // Delete a task
  const handleDeleteTask = async (taskId) => {
    setTasks((prevTasks) => prevTasks.filter((tasks) => tasks.id !== taskId));
    toast.warn("Task deleted successfully");

    try {
      await fetch(
        `https://task-manager-json-server-88du.onrender.com/tasks/${taskId}`,
        {
          method: "DELETE",
          body: "",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
    } catch (error) {
      toast.error("Error deleting task");
    }
  };

  // Edit a task
  const handleEditTask = (taskId) => {
    setEditTaskId(taskId);
    const taskToEdit = tasks.find((task) => task.id === taskId);
    setInputValue(taskToEdit.title);
  };

  // Update a task
  const handleUpdateTask = async () => {
    if (inputValue.trim() === "") {
      return;
    }

    const updatedTask = {
      title: inputValue,
      completed: false,
    };

    try {
      const response = await fetch(
        `https://task-manager-json-server-88du.onrender.com/tasks/${editTaskId}`,
        {
          method: "PUT",
          body: JSON.stringify(updatedTask),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      const updatedTaskData = await response.json();
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task.id === editTaskId
            ? { ...task, title: updatedTaskData.title }
            : task
        )
      );
      setInputValue("");
      setEditTaskId(null);
      toast.success("Task updated successfully");
    } catch (error) {
      toast.error("Error updating task");
    }
  };

  // Mark all tasks as completed
  const handleCompleteAll = async () => {
    setTasks((prevTasks) =>
      prevTasks.map((tasks) => ({ ...tasks, completed: true }))
    );
    let t = tasks;
    t.map(async (data) => {
      let newObj = {
        title: data.title,
        completed: true,
      };
      try {
        await fetch(
          `https://task-manager-json-server-88du.onrender.com/tasks/${data.id}`,
          {
            method: "PUT",
            body: JSON.stringify(newObj),
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        );
      } catch (error) {
        toast.error("Error completing all tasks");
      }
      return 0;
    });
    toast.success("All tasks completed successfully");
  };

  // Clear completed tasks
  const handleClearCompleted = () => {
    setTasks((prevTasks) => prevTasks.filter((task) => !task.completed));

    let t = tasks;
    t.map(async (data) => {
      if (data.completed === true) {
        try {
          await fetch(
            `https://task-manager-json-server-88du.onrender.com/tasks/${data.id}`,
            {
              method: "DELETE",
              body: "",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
              },
            }
          );
        } catch (error) {
          toast.error("Error deleting all completed task");
        }
      }
      return 0;
    });
    toast.warn("All completed tasks deleted");
  };

  // Handle filter change
  const handleFilterChange = (filterType) => {
    setFilter(filterType);
  };

  // Filter tasks based on the selected filter
  const filteredTasks = tasks.filter((task) => {
    if (filter === "all") {
      return true;
    } else if (filter === "completed") {
      return task.completed;
    } else if (filter === "uncompleted") {
      return !task.completed;
    }
    return true;
  });

  // Display loading message while data is being fetched
  if (isLoading) {
    return <div>Loading your tasks please wait...</div>;
  }

  // Render the todo list
  return (
    <>
      <div className="container">
        <ToastContainer />
        <div className="todo-app">
          <h2>
            <img src={todoImage} alt="todo-image" />
            Apna Task Manager
          </h2>
          <div className="row">
            <i className="fas fa-list-check" style={{ color: "#8e2de2" }}></i>
            <input
              type="text"
              className="add-task"
              id="add"
              placeholder="Add your task"
              autoFocus
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (editTaskId) handleUpdateTask();
                  else handleAddTask();
                }
              }}
            />
            <button
              id="btn"
              onClick={editTaskId ? handleUpdateTask : handleAddTask}
            >
              {editTaskId ? "Update" : "Add Task"}
            </button>
          </div>

          <div className="mid">
            <i className="fas fa-check-double" style={{ color: "#11998e" }}></i>
            <p
              id="complete-all"
              onClick={handleCompleteAll}
              style={{ color: "#11998e" }}
            >
              Complete all tasks
            </p>

            <p
              id="clear-all"
              onClick={handleClearCompleted}
              style={{ color: "#eb5951" }}
            >
              Remove comp tasks
            </p>
          </div>

          <ul id="list">
            {filteredTasks.map((task) => (
              <li key={task.id}>
                <input
                  type="checkbox"
                  id={`task-${task.id}`}
                  data-id={task.id}
                  className="custom-checkbox"
                  checked={task.completed}
                  onChange={() => handleTaskCheckboxChange(task.id)}
                />
                <label htmlFor={`task-${task.id}`}>{task.title}</label>
                <div>
                  <i
                    className="fa fa-pencil-square-o"
                    style={{
                      color: "#11998e",
                      height: "25px",
                      padding: "5px 0px",
                      borderRadius: "3px",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                    data-id={task.id}
                    onClick={() => handleEditTask(task.id)}
                  ></i>
                  <i
                    className="fa fa-trash"
                    style={{
                      color: "#eb5951",
                      height: "25px",
                      padding: "5px 0px",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    data-id={task.id}
                    onClick={() => handleDeleteTask(task.id)}
                  ></i>
                </div>
              </li>
            ))}
          </ul>

          <div className="filters">
            <div className="dropdown">
              <button className="dropbtn">Sort by</button>
              <div className="dropdown-content">
                <a id="all" onClick={() => handleFilterChange("all")}>
                  All
                </a>
                <a id="rem" onClick={() => handleFilterChange("uncompleted")}>
                  Uncompleted
                </a>
                <a id="com" onClick={() => handleFilterChange("completed")}>
                  Completed
                </a>
              </div>
            </div>

            <div className="completed-task">
              <p>
                Completed:{" "}
                <span id="c-count">
                  {tasks.filter((task) => task.completed).length}
                </span>
              </p>
            </div>
            <div className="remaining-task">
              <p>
                <span id="total-tasks">
                  Total Tasks: <span id="tasks-counter">{tasks.length}</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TodoList;
